export default {
  Login_confirm_agree: '確定即代表同意',
  Login_num_not_empty: '手機號和驗證碼不能為空',
  Login_illegal_mobile_number: '手機號長度不合法',
  Login_enter_mobile_number: '請填寫手機號！',
  Login_bind_mobile_phone: "綁定手機",
  Login_identity: "身份",
  Login_agree_rules: '請先同意《知鳥服務協議》以及《知鳥隱私政策》',
  password_not_empty: '密碼和確認密碼不能為空！',
  Login_rules_content01: '親愛的用戶，歡迎您使用平安知鳥APP、來做課軟件及相關服務！',
  Login_rules_content02: '深圳平安通信科技有限公司及其關聯公司（下稱公司或平安）擁有並經營知鳥網站（www.zhi-niao.com）、知鳥客戶端App等。',
  Login_rules_content03: '本協議是知鳥用戶（以下簡稱「您」或「用戶」）與平安之間關於用戶下載、安裝、使用知鳥APP、來做課軟件等平臺相關軟件或工具，並接受相應服務的法律協議。本協議由您和本公司簽訂。',
  Login_rules_content04: '「知鳥APP」作為一款移動學習APP，「企業獨立App」為基於知鳥APP底層構架生成的具有企業獨立logo的企業獨立App，「來做課軟件」為其輔助學習軟件，其中知鳥APP、企業獨立App、來做課軟件，以下簡稱「知鳥相關APP」或「平臺」。知鳥相關APP可為企業及個人用戶提供包括學習、製作、交流和信息儲存空間的服務，其中涵蓋了平安絕大多數專業系列的知識內容，用戶通過知鳥相關APP可以完成課件製作，可以下載學習，可以在線學習，也可以移動學習，課程內容精短，配合視頻動畫、遊戲闖關、答題競賽等方式多樣教學。 ',
  Login_rules_content05: '本協議所述「課件」即包括但不限於文字、圖片、視頻、flash、遊戲作品等。成為知鳥相關APP及本協議的尊貴用戶,您需先行註冊，且勾選「同意」按鈕，本協議自動生效，您即應遵守本協議所有條款。',
  Login_rules_content06: '1.  聲明及承諾',
  Login_rules_content07: '1.1	   本協議已對與您的權益有或可能具有重大關系的條款，及對本公司具有或可能具有免責或限製責任的條款用粗體字予以標註，請您註意。您確認，在您註冊成為知鳥用戶以接受本服務之前，您已充分閱讀、理解並接受本協議的全部內容，一旦您使用本服務，即表示您同意遵循本協議之所有約定。',
  Login_rules_content08: '1.2    您同意，本公司有權隨時對本協議內容進行單方面的變更，並以在本網站公告的方式予以公布，無需另行單獨通知您；若您在本協議內容公告變更後繼續使用本服務的，表示您已充分閱讀、理解並接受修改後的協議內容，也將遵循修改後的協議內容使用本服務；若您不同意修改後的協議內容，您應停止使用本服務。',
  Login_rules_content09: '1.3	   您保證，在您同意接受本協議並註冊成為知鳥用戶時，您已年滿10周歲，並在法定監護人的陪同下閱讀本協議，並特別註意未成年人使用條款，或者是在中華人民共和國境內（香港、澳門、臺灣地區除外）合法開展經營活動或其他業務的法人或其他組織；本協議內容不受您所屬國家或地區法律的排斥。不具備前述條件的，您應立即終止註冊或停止使用本服務。',
  Login_rules_content10: '1.4	   未成年人使用條款：本公司非常重視對未成年人個人信息的保護。若您是18周歲以下的未成年人，在使用本服務前，應事先取得您家長或法定監護人的書面同意。您在使用知鳥服務時，應自行判斷並自行決定是否與對方進行交易或轉賬給對方等，且您應自行承擔與此相關的所有風險。用戶的下載、安裝、使用、帳號獲取和登錄等行為將視為已接受本協議所有條款及其約束。',
  Login_rules_content11: '2.	權利與資質聲明',
  Login_rules_content12: '2.1    平安對知鳥相關APP均享有包括商標權、專利權、著作權、商業秘密等在內的全部知識產權及所有權。任何人未經平安書面許可，不得為任何商業或非商業目的，以任何形式對上述任一軟件以及上述軟件本身所包含的任一知識產權要素擅自使用（不包括用戶通過本APP，利用上述軟件自行上傳的課件），否則，平安將保留追究上述侵權行為法律責任的權利。',
  Login_rules_content13: '2.2    用戶於任何時間，通過知鳥相關APP發表的任何內容（包括但不限於：文字、圖片、視頻、flash、遊戲作品）均應被視為已授權平安對上述任一作品在其著作權的最大地域範圍內、最長保護期限內，免費、持續、不可撤銷、可再許可和獨家地使用，包括但不限於：復製權、發行權、出租權、展覽權、表演權、放映權、廣播權、信息網絡傳播權、攝製權、改編權、翻譯權、匯編權等以及《著作權法》規定的由著作權人享有的其他著作財產權利。並且，上述發表行為同樣應被視為，用戶已許可平安就任何主體涉嫌侵犯上述任一作品的行為，有權以自己名義單獨提起訴訟，並獲得全部賠償。',
  Login_rules_content14: '2.3	  用戶承諾，對其通過知鳥相關APP上傳或發布的所有內容（包括用戶名、昵稱、簽名）均擁有合法、完整的包括著作權、商標權等在內的知識產權或已獲得相關權利人的合法授權，未侵犯任何第三方的包括著作權、商標權、專利權、商業秘密等在內的知識產權及人身權等合法權益，否則，由此引發的任何訴訟、主張，用戶均應獨立承擔所有法律責任，就任何第三人針對平安的任何主張或訴訟，以及平安因此遭受的任何損失，用戶亦應承擔包括賠償在內的一切法律責任(一)本協議已對與您的權益有或可能具有重大關系的條款，及對本公司具有或可能具有免責或限製責任的條款用粗體字予以標註，請您註意。您確認，在您註冊成為知鳥用戶以接受本服務之前，您已充分閱讀、理解並接受本協議的全部內容，一旦您使用本服務，即表示您同意遵循本協議之所有約定。',
  Login_rules_content15: '3.  軟件許可範圍',
  Login_rules_content16: '3.1	   知鳥相關APP提供包括但不限於IOS、android等多個應用版本，用戶必須選所安裝終端相匹配的軟件版本。',
  Login_rules_content17: '3.2    授予用戶一項個人的、永久性、不可轉讓和非排他的使用許可，以使用知鳥相關APP。用戶可以為非商業目的在單一臺終端設備上安裝並使用知鳥相關APP。',
  Login_rules_content18: '3.3    本條及本協議其他條款未明示授權的其他一切權利仍歸平安所有。除非有書面明示，平安不放棄相關權益。',
  Login_rules_content19: '3.4    若用戶對知鳥相關APP有任何意見或改進的建議，均可向平安提出。',
  Login_rules_content20: '4.    權利限製',
  Login_rules_content21: '4.1	    禁止反向工程、反向編譯和反向匯編：用戶不得對知鳥相關APP進行反向工程（Reverse Engineer）、反向編譯（Decompile）或反向匯編（Disassemble），同時不得改動編譯在程序文件內部的任何資源。除法律、法規明文規定允許上述活動外，用戶必須遵守此協議限製。',
  Login_rules_content22: '4.2     組件分割:知鳥相關APP是作為一個單一產品而被授予許可使用，用戶不得將各個部分分開用於任何目的',
  Login_rules_content23: '4.3     個別授權:如需進行商業性的銷售、復製、分發，包括但不限於軟件銷售、預裝、捆綁等，必須獲得平安的書面授權和許可。',
  Login_rules_content24: '4.4     保留權利：本協議未明示授權的其他一切權利仍歸平安所有，用戶使用其他權利時必須獲得平安的書面同意',
  Login_rules_content25: '5     軟件的安裝、升級及終止',
  Login_rules_content26: '5.1     用戶可以直接從平安官網上獲取並安裝知鳥相關APP，也可以從平安授權的第三方應用中下載。 如果用戶從非以上的第三方獲取知鳥相關APP或與知鳥相關APP名稱相同的安裝程序，平安無法保證該軟件能夠正常使用，並對因此給用戶造成的損失不予負責。',
  Login_rules_content27: '5.2	    請下載並安裝適合的終端軟件版本，並請按照軟件提示步驟正確安裝。為提供更加優質、安全的服務，在知鳥相關APP安裝時平安可能推薦用戶安裝其他軟件，用戶可以選擇安裝或不安裝。',
  Login_rules_content28: '5.3	    如用戶不再需要使用知鳥相關APP，有權利自行卸載知鳥相關APP。',
  Login_rules_content29: '5.4	    為了保證知鳥相關APP及服務的安全性和功能的一致性，平安有權不經特別通知，而對知鳥相關APP做不定期更新，或者對軟件的部分功能效果進行改變或限製。為保證用戶的使用體驗，請及時下載最新版本並升級，平安不保證舊版知鳥相關APP繼續可用及對應的客戶服務',
  Login_rules_content30: '5.5     安擁有不經事先通知而修改軟件功能、中斷或中止軟件使用的權利。',
  Login_rules_content31: '6.	   用戶使用須知',
  Login_rules_content32: '6.1	   知鳥賬戶：是本公司向您提供的唯一編號。您可自行設置密碼，並用以查詢或計量您的預付、應收或應付款。您需使用本人電子郵箱或手機號碼，或者本公司允許的其它方式，例如通過掃描二維碼或識別生物特征的方式，作為登錄手段登錄該知鳥賬戶。',
  Login_rules_content32: '6.2	 賬戶註冊相關',
  Login_rules_content33: '除本協議另有規定或相關產品另有規則外，您須在客戶端註冊並取得本公司提供給您的知鳥賬戶，或在您於其他平安網站完成知鳥登錄名註冊，並且按照本公司要求提供相關信息完成激活後方可使用本服務。您同意：',
  Login_rules_content34: '6.2.1   按照知鳥要求準確提供並在取得該賬戶後及時更新您正確、最新及完整的身份信息及相關資料。若本公司有合理理由懷疑您提供的身份信息及相關資料錯誤、不實、失效或不完整的，本公司有權暫停或終止向您提供部分或全部知鳥服務。本公司對此不承擔任何責任，您將承擔因此產生的任何直接或間接支出。若因國家法律法規、部門規章或監管機構的要求，本公司需要您補充提供任何相關資料時，如您不能及時配合提供，本公司有權暫停或終止向您提供部分或全部知鳥服務。',
  Login_rules_content35: '6.2.2   您確認，只有您本人可以使用您的知鳥賬戶。在您決定不再使用該賬戶時，您應按照本協議規定向本公司申請註銷該賬戶',
  Login_rules_content36: '6.2.3   您同意，若您喪失全部或部分民事權利能力或民事行為能力，本公司有權根據有效法律文書（包括但不限於生效的法院判決、生效的遺囑等）或本公司認可的其他資料處置您知鳥賬戶內款項。',
  Login_rules_content37: '6.3	  用戶信息及賬戶安全',
  Login_rules_content38: '6.3.1	平安非常重視用戶的隱私權，將會盡最大努力保護用戶的個人信息。除法律法規規定的情形外，未經用戶許可平安不會向第三方公開、透露用戶個人信息。',
  Login_rules_content39: '6.3.2	平安擁有完善的信息管理安全製度，為保障用戶個人信息的安全，對重要用戶信息采用了專業的加密存儲與傳輸方式，以免用戶信息遭受未經授權的訪問、使用或披露。',
  Login_rules_content40: '6.3.3	用戶在使用知鳥相關APP的過程中，需要提供一些必要的個人信息，如手機號碼、地理位置等，因產品服務與實際使用功能相關聯，若用戶提供的信息不完整、不真實，則可能在使用過程中受限或無法使用部分功能。',
  Login_rules_content42: '6.3.4	用戶使用知鳥相關APP，即視為理解並同意以下授權條款：',
  Login_rules_content43: '6.3.5	用戶授權平安，除法律另有規定之外，將用戶本人提供給平安的信息、因享受平安服務而產生的信息（包括本協議簽署之前提供和產生的信息）以及平安根據本條約定查詢、收集的信息，用於平安及因服務必要而委托的合作夥伴為用戶本人提供服務、推薦產品、開展市場調查與信息數據分析。',
  Login_rules_content44: '6.3.6	用戶明確確認授權並許可平安向用戶留存的郵箱、手機、地址等發送商業信息。',
  Login_rules_content45: '6.3.7	為確保用戶信息的安全，平安及其合作夥伴對上述信息負有保密義務，並采取各種措施保證信息安全。',
  Login_rules_content46: '6.3.8   如用戶不同意上述授權條款的部分或全部，可致電客服熱線（95511）取消或變更授權。',
  Login_rules_content47: '6.4	帳號使用須知',
  Login_rules_content48: '6.4.1	知鳥相關APP帳號的所有權歸平安所有，用戶完成申請註冊手續後，僅獲得知鳥相關APP帳號的使用權，且該使用權僅屬於首次申請註冊人，同時，首次申請註冊人不得贈與、借用、租用、轉讓或售賣知鳥相關APP帳號或者以其他方式許可非首次申請註冊人使用知鳥相關APP帳號。非首次申請註冊人不得通過受贈、繼承、承租、受讓或者其他任何方式使用知鳥相關APP賬號。',
  Login_rules_content49: '6.4.2	用戶有責任妥善保管註冊帳戶信息及帳戶密碼的安全，用戶需要對本人註冊帳戶下的行為獨立承擔法律責任。用戶在任何情況下均不得向他人透露帳戶及密碼信息，否則，由此造成的任何損失，用戶均應自行承擔法律責任在懷疑他人使用自己帳號時，用戶應立即通知平安進行處理。',
  Login_rules_content50: '6.4.3	用戶長期不登錄其註冊的知鳥相關APP帳號，平安有權回收該帳號，並清理相關存儲數據，以免造成資源浪費，由此帶來的任何損失均由用戶自行承擔。',
  Login_rules_content51: '6.4.4	用戶需為本人註冊帳號下的一切行為獨立承擔負責，包括個人所發表的任何內容以及由此產生的任何後果。用戶應對知鳥相關APP賬號及其服務中的內容自行加以判斷，並承擔因使用而引起的所有風險，包括因對內容的正確性、完整性或實用性的依賴而產生的風險。 平安無法且不會對因前述風險而導致的任何損失或損害承擔責任。',
  Login_rules_content52: '7.	免責與責任限製',
  Login_rules_content53: '7.1	用戶對其通過知鳥相關APP上傳或發布的法人作品及特殊職務作品，如未按照其公司相關管理規定設置保密屬性，從而導致自身商業秘密泄露的，均應獨立承擔相關法律責任，知鳥相關APP對此無需承擔任何責任。',
  Login_rules_content54: '7.2	用戶在使用知鳥相關APP及服務時，須自行承擔如下來自平安不可掌控的風險內容，包括但不限於：',
  Login_rules_content55: '7.2.1	由於不可抗拒因素可能引起的個人信息丟失、泄漏等風險；',
  Login_rules_content56: '7.2.2	用戶必須選擇與所安裝手機相匹配的軟件版本，否則，由於軟件與手機型號不相匹配所導致的任何問題或損害，均由用戶自行承擔；',
  Login_rules_content57: '7.2.3	用戶發布的內容被他人轉發、分享，因此等傳播可能帶來的風險和責任；',
  Login_rules_content58: '7.2.4	由於網絡信號不穩定、帶寬資源不足等原因，所引起的軟件登錄失敗、資料同步不完整、頁面打開速度慢等風險；',
  Login_rules_content59: '7.2.5	如有需要，用戶在使用知鳥相關APP訪問第三方網站時，因第三方網站及相關內容所可能導致的風險，由用戶自行承擔；',
  Login_rules_content60: '7.3	用戶確認，其知悉知鳥相關APP所有功能及平安為實現知鳥相關APP各功能所進行的必要操作，其根據自身需求自願選擇使用知鳥相關APP及相關服務，因使用知鳥相關APP及相關服務所存在的風險和一切後果將完全由其自己承擔，平安不承擔任何責任。',
  Login_rules_content61: '7.4	用戶從非官方渠道下載知鳥相關APP，並因此受到廣告信息、手機病毒、惡意收費服務的影響及損失，均與知鳥相關APP無關。',
  Login_rules_content62: '7.5	知鳥相關APP經過詳細的測試，但不能保證與所有的軟硬件系統完全兼容，不能保證知鳥相關APP完全沒有錯誤。如果出現不兼容及軟件錯誤的情況，用戶可在將情況報告平安，獲得技術支持。如果無法解決兼容性問題，用戶可以刪除知鳥相關APP。',
  Login_rules_content63: '7.6	在適用法律允許的最大範圍內，對因使用或不能使用知鳥相關APP所產生的損害及風險，包括但不限於直接或間接的個人損害、商業贏利的喪失、貿易中斷、商業信息的丟失或任何其它經濟損失，平安不承擔任何責任。',
  Login_rules_content64: '7.7	對於因運營商系統或基礎網絡故障、計算機故障或病毒、信息損壞或丟失、計算機系統問題或其它任何不可抗力原因而產生損失，平安不承擔任何責任。',
  Login_rules_content65: '7.8	平安對不可抗力導致的損失不承擔責任。本服務條款所指不可抗力包括：天災、法律法規或政府指令的變更等。',
  Login_rules_content66: '8.	行為規範',
  Login_rules_content67: '8.1	用戶的行為不得違反《計算機信息網絡國際聯網安全保護管理辦法》、《互聯網信息服務管理辦法》、《互聯網電子公告服務管理規定》、《互聯網用戶賬號名稱管理規定》《全國人大常委會關於維護互聯網安全的決定》、《互聯網新聞信息服務管理規定》等相關法律規定，不得利用知鳥相關APP及服務製作、復製、發布、傳播如下侵犯其他用戶或第三方合法權益、幹擾知鳥相關APP正常運營的內容，不得利用知鳥相關APP及服務從事任何違法犯罪活動。包括但不限於：',
  Login_rules_content68: '1)	發布、傳送、傳播、儲存違反國家法律、危害國家安全統一、泄露國家秘密、破壞民族團結、破壞國家宗教政策、擾亂社會秩序、損害國家榮譽和利益、以非法民間組織名義的活動；',
  Login_rules_content69: '2)	發布、傳送、傳播、儲存違反社會穩定、公序良俗、社會公德以及侮辱、誹謗、淫穢或含有任何性或性暗示的、賭博、兇殺、恐怖或者教唆犯罪的、暴力的內容；',
  Login_rules_content70: '3)	發布、傳送、傳播、儲存侵害他人名譽權、隱私權、肖像權、知識產權、商業秘密等合法權利的內容；',
  Login_rules_content71: '4)	侵犯他人隱私、個人信息或資料；',
  Login_rules_content72: '5)  發表、傳送、傳播騷擾、廣告信息及垃圾信息；',
  Login_rules_content73: '6)	提交、發布虛假信息，或冒充、利用他人名義；',
  Login_rules_content74: '7)	虛構事實、隱瞞真相以誤導、欺騙他人；',
  Login_rules_content75: '8)	使用不雅或不恰當ID和昵稱；涉及反動、色情的頭像、簽名檔和發布不良內容；',
  Login_rules_content76: '9)	發表含有猥褻、色情、人身攻擊和反政府言論等非法或侵權言論的；',
  Login_rules_content77: '10)	從事非法商業活動；',
  Login_rules_content78: '11)	模仿管理人員ID或者他人ID，用以假冒管理人員或破壞管理人員形象',
  Login_rules_content79: '12)	使用發貼機等非法軟件進行違規發貼的行為；',
  Login_rules_content80: '13)	發表含有本協議禁止發布、傳播內容的文章；',
  Login_rules_content81: '14)	發表不符合版面主題，或者無內容的灌水內容；',
  Login_rules_content82: '15)	同一主題內容多次出現的；',
  Login_rules_content83: '16)	違反本協議規定，發布違規廣告的；',
  Login_rules_content84: '17)	發布內容或個人簽名會包含有嚴重影響用戶瀏覽的內容或格式的；',
  Login_rules_content85: '18)	其他平安認為不恰當的情況；',
  Login_rules_content86: '19)	其他違反法律法規、政策及公序良俗、社會公德或幹擾知鳥相關APP正常運營和侵犯其他用戶或第三方合法權益內容的信息；',
  Login_rules_content87: '8.2	用戶在遵守法律及本協議的前提下使用知鳥相關APP，在使用過程中不得侵犯平安就知鳥相關APP享有的任何權利、權益，不得有下列任一行為，包括但不限於：',
  Login_rules_content88: '1)	刪除知鳥相關APP及其副本上關於著作權、商標權等知識產權的信息；',
  Login_rules_content89: '2)	不得製作、發布、使用、傳播用於竊取知鳥相關APP帳號及他人個人信息、財產的惡意程序；',
  Login_rules_content90: '3)	對知鳥相關APP進行反向工程、反向匯編、反向編譯，或者以其他方式嘗試發現知鳥相關APP的源代碼；',
  Login_rules_content91: '4)	對平安擁有知識產權的內容進行使用、出租、出借、復製、修改、鏈接、轉載、匯編、發表、出版、建立鏡像站點等；',
  Login_rules_content92: '5)	對知鳥相關APP或者知鳥相關APP運行過程中釋放到任何終端內存中的數據、軟件運行過程中客戶端與服務器端的交互數據，以及知鳥相關APP運行所必需的系統數據，進行復製、修改、增加、刪除、掛接運行或創作任何衍生作品，形式包括但不限於使用插件、外掛或非平安經授權的第三方工具/服務接入知鳥相關APP和相關系統；',
  Login_rules_content93: '6)	通過修改或偽造軟件運行中的指令、數據，增加、刪減、變動軟件的功能或運行效果，或者將用於上述用途的軟件、方法進行運營或向公眾傳播，無論這些行為是否為商業目的；',
  Login_rules_content94: '7)	通過非平安開發、授權的第三方軟件、插件、外掛、系統，登錄或使用平安軟件及服務，或製作、發布、傳播上述工具；',
  Login_rules_content95: '8)	自行或者授權他人、第三方軟件對知鳥相關APP及其組件、模塊、數據進行幹擾。',
  Login_rules_content96: '9)	任何用戶發現知鳥相關APP內的內容涉嫌侮辱或者誹謗他人、侵害他人合法權益的或違反知鳥相關APP協議的，有權按投訴規則進行投訴。',
  Login_rules_content97: '9.	法律責任及違約處理！',
  Login_rules_content98: '9.1	如果用戶違反上述行為規範或本協議的任何其他約定，或者收到其他用戶的舉報或投訴，平安有權不經通知隨時對相關內容進行刪除，並視行為情節對違規帳號處以包括但不限於警告、限製或禁止使用部分或全部功能、封禁帳號並清空所有發言，直至註銷賬號的處罰， 情節嚴重的，還將承擔相應法律責任。',
  Login_rules_content99: '9.2	因違反上述行為規範或本協議的任何其他約定，導致或產生任何第三方主張的任何索賠、要求，用戶均應獨立承擔責任；任何第三人針對平安的任何主張或訴訟，以及平安因此遭受的任何損失，用戶亦應承擔包括賠償在內的一切法律責任。',
  Login_rules_content101: '9.3	平安有權依合理判斷對其認為確已違反有關法律法規或本協議規定的用戶進行處罰，對違法違規的任何用戶采取包括但不限於中斷使用許可、停止提供服務、限製使用、追究法律責任等措施，以及依據法律法規保存有關信息並向有關部門報告等，因此產生的一切法律責任，用戶均應獨自承擔。',
  Login_rules_content102: '9.4	如因知鳥相關APP所使用的第三方軟件或技術引發任何糾紛，應由該第三方負責解決並獨立承擔所有法律責任，平安不承擔任何責任。平安不對第三方軟件或技術提供客服支持，若您需要獲取支持，請自行與第三方聯系。',
  Login_rules_content103: '10.	其他註意事項',
  Login_rules_content104: '10.1	知鳥相關APP在非wifi使用場景中，會產生數據流量費用，用戶需自行向運營商了解相關資費，並自行承擔相關費用。',
  Login_rules_content105: '10.2用戶在使用知鳥相關APP某一特定服務時（如視頻服務），該服務可能會另有單獨的協議、相關業務規則等（以下統稱為「單獨協議」），用戶在使用該項服務前請仔細閱讀並同意相關的單獨協議。',
  Login_rules_content106: '10.3平安將會盡力保障用戶在知鳥相關APP及服務中的數據存儲安全，但是， 平安並不能完全保證所有用戶數據完整，對於可能出現的存儲失敗、或服務終止、數據被刪除等情況，平安沒有義務向用戶提供或返還任何數據，也無需對用戶因上述情形而遭受的任何損失承擔包括賠償在內的任何法律責任。',
  Login_rules_content107: '10.4	平安有權不定期更新本協議條款，一旦本協議的內容發生變動，平安將會通過適當方式提示用戶修改內容。',
  Login_rules_content108: '10.5	用戶可以在知鳥相關APP的最新版本中查閱更新後的協議條款。平安提示協議條款更新後，如用戶不同意平安對本協議相關條款所做更新，有權停止使用知鳥相關APP及相應服務，如用戶繼續使用知鳥相關APP，即視為已接受更新後的協議條款。',
  Login_rules_content109: '10.6	本協議的成立、生效、履行、解釋及糾紛解決，均適用中華人民共和國大陸地區法律（不包括沖突法）。所有與本合同有關的爭議應通過甲乙雙方友好協商解決。如合同雙方經協商仍未能解決爭議，可將爭議提交至深圳仲裁委員會進行仲裁。仲裁裁決為終局裁決，對雙方均有約束力。由該仲裁產生的一切相關費用均由敗訴方承擔。',
  Login_rules_content110: '10.7	除爭議事項外，各方應繼續行使各自在本合同項下的其他權利，履行各自在本合同項下的其他義務。',
  Login_rules_content111: '10.8	如本協議中的任何條款因任何原因被判定為完全或部分無效或不具有執行力，本協議的其余條款仍應有效並且有執行力。',
  Login_pingan_company:'深圳平安通信科技有限公司',
  Login_foot_company: '親愛的用戶，歡迎您使用平安知鳥APP、來做課軟件及相關服務！',
  Login_dialog_title: '請選擇要登錄的{title}：',
  Login_send_message: '短信即將發送至：',
  Login_enter_code: "請輸入右側驗證碼",
  Login_code_error: '驗證碼錯誤',
  Login_code: '驗證碼',
  Login_register_agree: "註冊即代表同意",
  Login_get_mes_code: '獲取短信驗證碼',
  Login_get_code_again: '{count}後可重新獲取',
  Login_wrong_format_number: '手機號格式錯誤',
  Login_mobile_number: '手機號',
  Login_enter_mobile_number: "請輸入您的手機號碼",
  Login_enter_six_code: "請輸入6位短信驗證碼",
  Login_service_agreement: '《{isCustomLogin}服務協議》',
  Login_privacy_policy: '《{isCustomLogin}隱私政策》',
  Login_password_format_error: '密碼格式錯誤',
  Login_new_password: '新密碼',
  Login_password_rules: "請輸入至少8位，並且包含英文和數字",
  Login_password_inconsistent: '密碼不一致',
  Login_confirm_password: '確認密碼',
  Login_enter_again_pwd: "請再次輸入密碼",
  Login_done: '完 成',
  Login_technical_support: '由知鳥提供技術支持',
  Login_register: '註冊',
  Login_login: '登錄',
  Login_QR_code_updated: '報名二維碼有更新，請刷新頁面再重試。',
  Login_signed_up: '我已報名成功，',
  Login_sign_in_now: '立即登錄',
  Login_QR_code_payment: '手機掃描二維碼完成報名付款',
  Login_welcome_use: '歡迎使用',
  Login_login_empty: '登 錄',
  Login_one_account_login: '一賬通登錄',
  Login_username_pwd_empty: '用戶名和密碼不能為空！',
  Login_code_not_empty: '驗證碼不能為空！',
  Login_slider_verification: '請完成滑塊驗證碼校驗！',
  Login_pwd: '密碼',
  Login_remember_pwd: '記住密碼',
  Login_forgot_pwd: '忘記密碼',
  Login_register_accout: '賬戶註冊',
  Login_pwd_free_login: '手機號登錄',
  Login_account_login: '郵箱登錄',
  Login_accout_pwd_error: '賬戶或密碼錯誤',
  Login_accout: '賬戶',
  Login_enter_phone_email: "請輸入手機號或郵箱",
  Login_enter_accout_pwd: '請輸入賬戶密碼',
  Login_private_agreement_title: '版本生效時間：2020年6月5日',
  Login_private_agreement01: '【特別提示】',
  Login_private_agreement02: '請在使用知鳥產品（或服務）前，仔細閱讀並了解《知鳥隱私權政策》（以下簡稱「本隱私權政策」，尤其是加粗或劃線的內容。閱讀過程中，如您有任何疑問，可通過電話或電郵方式獲得幫助。一旦您點擊「同意」本隱私權政策，我們將視為您充分理解並同意本隱私權政策。',
  Login_private_agreement03: '【深圳平安通信科技有限公司】（註冊地址：深圳市前海深港合作區臨海大道59號海運中心主塔樓319號;個人信息保護責任人聯系方式：400-603-8258；以下簡稱「我們」）深知個人信息對您的重要性，並會盡全力保護您的個人信息安全可靠。我們致力於維持您對我們的信任，恪守以下原則，保護您的個人信息：權責一致原則、目的明確原則、選擇同意原則、最少夠用原則、確保安全原則、主體參與原則、公開透明原則。同時，我們承諾，我們將按業界成熟的安全標準，采取相應的安全保護措施來保護您的個人信息。',
  Login_private_agreement04: '為了向您提供優質服務，知鳥主要需要獲取以下權限和信息。系統將彈框提示，建議您允許獲取相關權限。',
  Login_private_agreement05: '獲取設備信息權限。',
  Login_private_agreement06: '當您登錄本軟件時，我們會收集設備信息用於硬件綁定。',
  Login_private_agreement07: '獲取相機權限',
  Login_private_agreement08: '用於二維碼識別、人臉識別功能。如您拒絕授權，您將無法使用這些功能，但不影響您正常使用其他功能。',
  Login_private_agreement09: '獲取啟用存儲讀取權限',
  Login_private_agreement10: '用於使用本軟件服務中，將瀏覽圖片或者文字信息保存至手機存儲中。如您拒絕授權，您將無法保存圖片或者文字信息，但不影響您正常使用其他功能。',
  Login_private_agreement11: '獲取位置信息權限',
  Login_private_agreement12: '用於與好友聊天中發送位置定位、面授班地理位置簽到功能。如您拒絕授權，您將無法發送定位功能及簽到，但不影響您正常使用其他功能。',
  Login_private_agreement13: '讀取日歷計劃權限',
  Login_private_agreement14: '用於將重要事項加入日歷提醒。如您拒絕授權，您將無法使用該功能，但不影響您正常使用其他功能。',
  Login_private_agreement15: '使用本軟件服務過程中，還將可能使用其他權限，詳見本軟件服務隱私政策。',
  Login_private_agreement16: '本隱私權政策將幫助您了解以下內容：',
  Login_private_agreement17: ' •	 我們如何收集和使用您的個人信息',
  Login_private_agreement18: ' •	 我們如何使用Cookie和同類技術',
  Login_private_agreement19: ' •	 我們如何共享、轉讓、公開披露您的個人信息',
  Login_private_agreement20: ' •	 我們如何保護和保存您的個人信息',
  Login_private_agreement21: ' •	 您的權利',
  Login_private_agreement22: ' •	 我們如何處理未成年人的信息',
  Login_private_agreement23: ' •	 本隱私權政策如何更新',
  Login_private_agreement24: ' •	 您如何與我們取得聯系',
  Login_private_agreement25: '一、我們如何收集和使用您的個人信息',
  Login_private_agreement26: '您同意，在下列環節向我們提供下列信息，並授權我們識別、記錄、保存並在為您提供服務時使用下列信息。同時您授權我們可在需要第三方配合為您提供服務的時候向該第三方提供必要的信息。',
  Login_private_agreement27: '（一）註冊成為用戶',
  Login_private_agreement28: '在創建賬號時，您需提供以下信息：您的姓名、手機號、電子郵箱地址、創建的用戶名和密碼。',
  Login_private_agreement29: '在註冊過程中，如果您提供以下額外信息，將有助於我們給您提供更好的服務和體驗：工作職位、公司。因產品服務與實際使用相關聯，若用戶提供的信息不完整、不真實，則可能在使用過程中受限或無法使用部分功能。',
  Login_private_agreement30: '（二）頁面內容展示',
  Login_private_agreement31: '除法律另有規定之外，我們將您本人提供給本軟件的信息、因享受本軟件服務而產生的信息（包括本協議簽署之前提供和產生的信息）及之本軟件根據本條約定查詢、收集的信息，用於本軟件及因服務必要而委托的合作夥伴為用戶本人提供服務、推薦產品、開展市場調查與信息數據分析。',
  Login_private_agreement32: '為了能開展內部數據分析和研究，第三方SDK統計服務，改善我們的產品或服務，僅在您使用軟件服務過程中，我們會評估必要性在最小範圍內收集您的一些數據。',
  Login_private_agreement33: '我們收集數據是根據您與我們的互動和您所做出的選擇，包括您的隱私設置以及您使用的產品和功能。我們收集的數據可能包括SDK/API/JS代碼版本、瀏覽器、互聯網服務提供商、IP地址、平臺、時間戳、應用標識符、應用程序版本、應用分發渠道、獨立設備標識符、iOS廣告標識符（IDFA)、安卓廣告主標識符、網卡（MAC）地址、國際移動設備識別碼（IMEI）、設備型號、終端製造廠商、終端設備操作系統版本、會話啟動/停止時間、語言所在地、時區和網絡狀態（移動信號和WiFi信號）、硬盤、藍牙、CPU和電池使用情況，並可能對從您的各種設備上收集到的信息進行關聯。',
  Login_private_agreement34: '當您開啟設備定位功能並使用我們基於位置提供的相關服務時，我們可能會收集和處理有關您的設備信息、位置信息、網絡身份標識信息，以使得您不需要手動輸入自身地理坐標就可獲得相關服務。我們會使用各種技術進行定位，這些技術包括 IP 地址、GPS 以及能夠提供相關信息的其他傳感器（比如可能會為我們提供附近設備、Wi-Fi 接入點和基站的信息）。您可以通過系統授權關閉定位功能，停止我們對您的地理位置信息的收集，但之後您可能將無法使用相關服務或功能，或者無法達到相關服務擬達到的效果。',
  Login_private_agreement35: '（三）商品的展示與購買',
  Login_private_agreement36: '1.虛擬商品的下單與支付',
  Login_private_agreement37: '知鳥內的付費類虛擬商品，包括但不限於課程、電子書、聽書、付費直播、智能陪練、學習地圖，需要您支付響應金額的貨幣下單並支付完成後使用，為實現付費類虛擬商品的下單功能，我們需要獲取您的知鳥帳號，下單完成後，您可選擇使用知鳥賬戶余額或與知鳥合作的第三方支付機構（Apple支付等非余額支付方式，以下稱「支付機構」）所提供的支付服務，支付功能需收集您的知鳥帳號，但我們需要將您的知鳥訂單號和交易金額與這些支付機構共享以實現其確認您的支付指令並完成支付。',
  Login_private_agreement38: '商城功能的使用',
  Login_private_agreement39: '知鳥商城主要以實體商品的展示和銷售為主，在您使用商城內的以下功能時，我們按照最少夠用原則收集您的個人信息並用於相應功能的實現：',
  Login_private_agreement40: '（1）商品的展示、加購與搜索功能',
  Login_private_agreement41: '為保證您準確挑選您所需的商品或服務，我們在知鳥App商城內為您提供商品展示、搜索及加入購物車的功能，為此我們會收集您的知鳥帳號。',
  Login_private_agreement42: '（2）商品的購買',
  Login_private_agreement43: '當您下單您選購的商品或服務時，知鳥系統會生成您購買該商品或服務的訂單，我們會收集您的知鳥帳號，您還需要在訂單中填寫您的收件人姓名、電話號碼、收貨地址，如您需要開具發票，您還需提供發票擡頭、稅號以及用於接收發票的手機號或郵箱，如您選擇購買的是線下大課產品，您還需要提供學員的姓名、電話和郵箱，用於學員登記和課程相關信息的接收。',
  Login_private_agreement44: '下單完成後，您可選擇使用知鳥賬戶余額或與知鳥合作的支付機構所提供的支付服務，支付功能僅會收集您的得到賬號，但我們需要將您的得到訂單號和交易金額與這些支付機構共享以實現其確認您的支付指令並完成支付。',
  Login_private_agreement45: '（3）商品的交付',
  Login_private_agreement46: '在當您下單並在線完成支付後，與知鳥合作的第三方配送公司將為您完成訂單的交付。您知曉並同意與知鳥合作的第三方配送公司會在上述環節內使用您的訂單信息以保證您的訂購的商品能夠安全送達。',
  Login_private_agreement47: '3.訂單管理功能',
  Login_private_agreement48: '為便於您了解查詢訂單信息並對訂單信息進行管理，我們會收集您在使用我們服務過程中產生的訂單信息用於向您展示及便於您對訂單進行管理。',
  Login_private_agreement49: '（四）面授班',
  Login_private_agreement50: '1. 面授班報名',
  Login_private_agreement51: '知鳥支持用戶通過掃描二維碼完成面授班的報名動作，為此，我們需要申請使用相機權限以掃描二維碼，同時獲取您的賬號信息，以校驗是否符合面授班的報名條件。',
  Login_private_agreement52: '2. 面授班簽到',
  Login_private_agreement53: '（1）掃碼簽到',
  Login_private_agreement54: '知鳥為用戶提供線上線下混合式學習形式，培訓過程中，學員可以通過掃碼的方式上報簽到記錄，管理員將二維碼投放之後，學員授權知鳥獲取相機權限，掃描二維碼完成簽到信息上報。',
  Login_private_agreement55: '（2）人臉識別',
  Login_private_agreement56: '管理員在設置簽到規則時，可以選擇人臉信息的識別校驗，確保簽到人與賬號是同一個人。該情況下，我們需申請使用相機權限並收集您的人臉信息數據方可完成簽到操作，如拒絕，則會導致因無法獲取簽到人的人臉信息，校驗失敗導致無法簽到成功。',
  Login_private_agreement57: '（3）地理位置',
  Login_private_agreement577:'管理員在設置簽到規則時，可以選擇地理位置信息的識別校驗，確保簽到人所處位置，與面授班要求的辦班地點在同一區域。該情況下，用戶必須同意獲取定位權限方可完成簽到操作，如拒絕，則會導致因無法獲取簽到人的位置信息，校驗失敗導致無法簽到成功。',
  Login_private_agreement58: '3. 作業管理',
  Login_private_agreement59: '（1）文字信息編輯',
  Login_private_agreement60: '學員提交作業或講師點評作業內容，支持通過語音輸入的方式，轉換成文字進行快速編輯。當用戶希望使用語音輸入時，需要允許獲取麥克風權限，如禁止授予該權限，可以通過手動輸入文字的方式處理，不影響功能使用。',
  Login_private_agreement61: '（2）上傳附件',
  Login_private_agreement62: '作業提交，支持用戶上傳附件，包括圖片、Word、excel等格式的文件。圖片格式，需要獲取相機和相冊權限，以便拍攝或從相冊中獲取合適的圖片內容。如果是Word、Excel等格式文件，需要獲取手機的存儲權限，以便從手機本地獲取相關文檔進行上傳。',
  Login_private_agreement63: '4. 講師信息',
  Login_private_agreement64: '（1）頭像更新',
  Login_private_agreement65: '講師可以在APP端自行更新頭像，為此需要獲取相機和相冊權限，以便拍攝或從相冊中獲取合適的照片。',
  Login_private_agreement66: '（2）文字信息編輯',
  Login_private_agreement67: '在編輯講師的個人優勢、工作經歷、授課經歷、培訓經歷、所獲榮譽、認證資質字段的文字信息時，支持用戶通過語音輸入的方式，轉換成文字進行快速編輯。當用戶希望使用語音輸入時，需要允許獲取麥克風權限，如禁止授予該權限，可以通過手動輸入文字的方式處理，不影響功能使用。',
  Login_private_agreement68: '（五）考試',
  Login_private_agreement69: '1. 考前實名認證',
  Login_private_agreement70: '管理員發布實名認證的考試時，需在用戶進入考試前進行實名認證，確保參考人員、身份證信息與賬號是同一個人。該情況下，用戶必須同意獲取相機和相冊權限方可完成人臉識別、拍攝或從相冊中獲取身份證件照片上傳，如拒絕，則會導致因無法獲取人臉信息與身份證圖片信息，無法完成實名認證與進入考試。',
  Login_private_agreement71: '2. 人臉識別監考',
  Login_private_agreement72: '管理員發布考試時，可以選擇人臉識別校驗的監考模式，確保考試人員與賬號是同一個人。該情況下，用戶必須同意獲取相機權限方可完成監考考試，如拒絕，則會導致因無法獲取考試人員的人臉信息，無法正常進入考試。',
  Login_private_agreement73: '3. 答案上傳附件',
  Login_private_agreement74: '考試中包含復雜公式的主觀題，支持用戶上傳附件為圖片格式的答案。圖片格式，需要獲取相機和相冊權限，以便拍攝或從相冊中獲取合適的圖片內容。',
  Login_private_agreement75: '4. 考試功能使用',
  Login_private_agreement76: '為保證用戶能正常參與知鳥內的各項考試，提交答案，獲取考試成績等個人相關數據，為此我們會收集用戶的知鳥帳號。',
  Login_private_agreement77: '（六）問卷功能',
  Login_private_agreement78: '為保證用戶能正常參與知鳥內的各項問卷調研，提交問卷結果，為此我們會收集用戶的知鳥帳號。',
  Login_private_agreement79: '（七）學習全景圖/學習地圖',
  Login_private_agreement80: '為保證用戶能正常使用知鳥的學習全景圖/學習地圖功能，完成此功能中相關資源學習，記錄用戶學習狀態，為此我們會收集用戶的知鳥帳號。',
  Login_private_agreement81: '（八）直播',
  Login_private_agreement82: '為保證直播的連麥、開播的正常進行，我們會取得用相機和麥克風的權限；當用戶進行預約直播時，我們將寫入用戶的日歷數據；部分用戶報告故障後，我們會讀取系統底層日誌；基於數據分析以及安全考慮，在用戶的允許情況下，我們會讀取用戶的定位、以及手機的SIM卡或IMEI信息；',
  Login_private_agreement83: '（九）小視頻',
  Login_private_agreement84: '為保證小視頻的錄製正常進行，我們會取得用相機、麥克風與相冊的權限。',
  Login_private_agreement85: '（十）智能陪練',
  Login_private_agreement86: '為保證用戶能正常使用知鳥的智能陪練功能，完成語音識別與微表情識別，我們會取得用相機、麥克風的權限。',
  Login_private_agreement87: '（十一）學習計劃與學習成就功能',
  Login_private_agreement88: '1.學習計劃功能',
  Login_private_agreement89: '我們為您提供學習計劃功能，您可默認使用我們為您製定的學習計劃，也可根據您的自身情況和需求製定和調整您的學習計劃，為此，我們需要獲取您的知鳥帳號、軟件使用情況，您也可以選擇不使用此項功能，如您不使用此項功能，我們則不會為實現此項功能獲取您的個人信息。',
  Login_private_agreement90: '2.學習成就功能',
  Login_private_agreement91: '我們為您提供學習成就功能，記錄您的學習數據以為您授予勛章、證書，並形成您的學習積分，為此，我們需要獲取您的知鳥帳號、軟件使用記錄以實現前述功能。',
  Login_private_agreement92: '（十二）知圈',
  Login_private_agreement93: '為保證用戶能在知圈發帖、回帖中添加圖片，我們會取得相機與相冊的權限。',
  Login_private_agreement94: '當您與我們聯系或提出售中售後、爭議糾紛處理申請時，為了保障您的帳號安全，我們需要您提供必要的個人信息以核驗您的用戶身份。',
  Login_private_agreement95: '為便於與您聯系、盡快幫助您解決問題或記錄相關問題的處理方案及結果，我們可能會保存您與我們的通信/通話記錄及相關內容（包括帳號信息、訂單信息、您為了證明相關事實提供的其他信息，或您留下的聯系方式信息），如果您針對具體訂單進行咨詢、投訴或提供建議的，我們會使用您的帳號信息和訂單信息。',
  Login_private_agreement96: '為了提供服務及改進服務質量的合理需要，我們還可能使用的您的其他信息，包括您與客服聯系時您提供的相關信息。',
  Login_private_agreement97: '（十三）保障交易安全',
  Login_private_agreement98: '為提高您使用我們及我們關聯公司、合作夥伴提供服務的安全性，保護您或其他用戶或公眾的人身財產安全免遭侵害，更好地預防釣魚網站、欺詐、網絡漏洞、計算機病毒、網絡攻擊、網絡侵入等安全風險，更準確地識別違反法律法規或知鳥相關協議規則的情況，我們可能使用或整合您的賬號信息、交易信息、設備信息、軟件使用記錄、點擊記錄以及我們關聯公司、合作夥伴取得您授權或依據法律共享的信息，來綜合識別您賬戶及交易風險、進行身份驗證、檢測及防範安全事件，並依法采取必要的記錄、審計、分析、處置措施。',
  Login_private_agreement99: '（十四）虛擬商品在線使用',
  Login_private_agreement100: '對於知鳥內的虛擬商品，包括課程、聽書、電子書、直播、智能陪練及學習地圖，我們為您提供了在線使用功能（每一個具體虛擬商品的在線使用功能可能略有不同，以知鳥內顯示的功能為準），您可以在相應的界面中進行評論、留言、轉發、記筆記，也可以進行收藏、下載、分享以及購買後贈送，為此，我們需要收集您的知鳥帳號、軟件使用記錄以實現前述功能。',
  Login_private_agreement101: '請註意，您公開發布的信息中可能會涉及您或他人的個人信息甚至個人敏感信息。請您更加謹慎地共享甚至公開分享相關信息。',
  Login_private_agreement102: '（十五）客服與售後功能',
  Login_private_agreement103: '當您與我們聯系或提出售中售後、爭議糾紛處理申請時，為了保障您的帳號安全，我們需要您提供必要的個人信息以核驗您的用戶身份。',
  Login_private_agreement104: '為便於與您聯系、盡快幫助您解決問題或記錄相關問題的處理方案及結果，我們可能會保存您與我們的通信/通話記錄及相關內容（包括帳號信息、訂單信息、您為了證明相關事實提供的其他信息，或您留下的聯系方式信息），如果您針對具體訂單進行咨詢、投訴或提供建議的，我們會使用您的帳號信息和訂單信息。',
  Login_private_agreement105: '為了提供服務及改進服務質量的合理需要，我們還可能使用的您的其他信息，包括您與客服聯系時您提供的相關信息。',
  Login_private_agreement106: '（十六）為您提供其他附加功能',
  Login_private_agreement107: '在您使用軟件服務過程中，為了保證您能正常使用產品功能，我們僅會在使用期間基於最大必要性以及最小範圍的原則收集您的一些信息，並向系統申請您的以下設備權限，申請前我們會征詢您的同意，您可以選擇「允許」或「禁止」權限申請；申請成功後，您可以隨時進入手機「設置-權限管理」中關閉相應權限，權限關閉後相關產品功能可能無法正常使',
  Login_private_agreement108: '這些附加服務包括：',
  Login_private_agreement109: '1.個性化內容服務',
  Login_private_agreement110: '我們會根據您的軟件使用情況對您進行定製化的內容服務，例如為您推薦適合您的商品或服務等，為此，我們需要獲取您的知鳥帳號、軟件使用記錄。若您不同意使用個性化內容推薦，您可以通過「我的」-「設置」-「關閉個性化」將此功能關閉。',
  Login_private_agreement111: '2.數據統計與產品優化',
  Login_private_agreement112: '為了通過數據統計對產品進行優化，我們只在每次啟動App時收集一次您的設備MAC地址，唯一設備識別碼、廣告追蹤標識符（IDFA）、知鳥帳號、性別、出生年份、學歷、行業、職業、軟件使用記錄、點擊記錄、IP地址。',
  Login_private_agreement113: '3.基於相機、相冊權限的附加服務',
  Login_private_agreement114: '您可以在開啟相機、相冊權限後使用該功能，以實現頭像上傳、意見反饋、掃描二維碼、獲取人臉信息。',
  Login_private_agreement115: '4.基於麥克風權限的附加服務',
  Login_private_agreement116: '我們僅在講師使用直播過程中，通過開啟麥克風權限以實現在在線直播界面發送語音進行交流、答疑，學員可以進行連麥與講師進行語音交流，可以使用語音轉文字功能，減少手動輸入操作，提升體驗。',
  Login_private_agreement117: '5.基於位置定位的附加功能',
  Login_private_agreement118: '我們僅在您使用面授班掃碼地理位置簽到功能時，向您的手機系統申請「位置權限」。',
  Login_private_agreement119: '6.基於屏幕常亮權限的附加功能',
  Login_private_agreement120: '為了讓您觀看視頻或直播時不會因為手機息屏造成不好的體驗，我們將會在首次安裝APP時向系統申請「屏幕常亮權限」。',
  Login_private_agreement121: '7. 基於獲取設備信息權限的附加功能',
  Login_private_agreement122: '為了您的賬號安全，我們只在每次啟動App時收集一次您的硬件設備信息，並與系統上的設備信息進行匹配，從而評估您的賬號登錄是否存在風險。在此過程中，我們會向系統申請「獲取設備信息權限」。',
  Login_private_agreement123: '為了給您提供更優質的服務，我們可能會根據產品功能向系統申請您的其他設備權限，如果您拒絕開啟相應設備權限，您可以隨時進入手機「設置-權限管理」中關閉相應權限，權限關閉後相關產品功能可能無法正常使用，請您理解。',
  Login_private_agreement124: '（十七）第三方軟件開發包（SDK）個人信息收集情況',
  Login_private_agreement125: '為了使您能夠在使用知鳥時接收信息推送、在第三方平臺分享信息、利用第三方平臺賬號進行登錄及保障您的賬號安全等，本平臺中集成了由第三方公司開發、提供的軟件開發包（SDK），這些軟件開發包（SDK）在實現功能時需要采集部分信息才可實現，具體如下：',
  Login_private_agreement126: '1、我們使用高德地圖SDK，由高德軟件有限公司提供，在企業聊天發送位置功能時，獲取您的位置信息。',
  Login_private_agreement127: '2、使用平安聲紋SDK，由平安科技股份有限公司提供，在聲紋登錄時，獲取您的聲紋信息。',
  Login_private_agreement128: '3、使用平安人臉SDK，由平安科技股份有限公司提供，在人臉登錄、人臉監學、監考功能，獲取您的面部信息。',
  Login_private_agreement129: '4、使用微信分享SDK，由騰訊科技有限公司提供，可以分享課程和直播到微信朋友及朋友圈',
  Login_private_agreement130: '（十八）與您溝通',
  Login_private_agreement131: '我們會利用收集的信息（例如您的手機號碼、電子郵件地址）直接與您溝通或互動。例如，如果我們或我們的關聯公司檢測到異常登錄活動。',
  Login_private_agreement132: '（十九）改善和運營知鳥產品和服務',
  Login_private_agreement133: '我們使用收集的信息來提供並改進我們及關聯方、合作方提供的產品和服務，並進行必要的業務運營，例如運營產品或提供服務，評估、維護和改進產品和服務的性能，開發新的產品和服務、提供客戶支持等。',
  Login_private_agreement134: '為改進我們及關聯方、合作方的產品和服務，我們也可能會對產品使用情況進行統計和分析。同時，知鳥可能會與關聯方、合作方、公眾共享這些統計信息，以展示我們服務的整體使用趨勢，但這些統計信息將不會包含您的任何身份識別信息。',
  Login_private_agreement135: '（二十）其他用途',
  Login_private_agreement136: '當我們要將信息用於本隱私協議未載明的其他用途，將基於特定目的收集而來的信息用於其他目的時，會事先征求您的同意。',
  Login_private_agreement137: '二、我們如何使用 Cookie 和同類技術',
  Login_private_agreement138: '（一）Cookie',
  Login_private_agreement139: '為確保網站正常運轉，我們會在您的計算機或移動設備上存儲名為 Cookie 的小數據文件。Cookie 通常包含標識符、站點名稱以及一些號碼和字符。',
  Login_private_agreement140: '我們不會將 Cookie 用於本政策所述目的之外的任何用途。您可根據自己的偏好管理或刪除 Cookie。您可以清除計算機上保存的所有 Cookie，大部分網絡瀏覽器都設有阻止 Cookie 的功能。但如果您這麽做，則需要在每一次訪問我們的網站時親自更改用戶設置。',
  Login_private_agreement141: '（二）網站信標和像素標簽',
  Login_private_agreement142: '除 Cookie 外，我們還會在網站上使用網站信標和像素標簽其他同類技術。例如，我們向您發送的電子郵件可能含有鏈接至我們網站內容的點擊 URL。如果您點擊該鏈接，我們則會跟蹤此次點擊，幫助我們了解您的產品或服務偏好並改善客戶服務。網站信標通常是一種嵌入到網站或電子郵件中的透明圖像。借助於電子郵件中的像素標簽，我們能夠獲知電子郵件是否被打開。如果您不希望自己的活動以這種方式被追蹤，則可以隨時從我們的寄信名單中退訂。',
  Login_private_agreement143: '三、我們如何共享、轉讓、公開披露您的個人信息',
  Login_private_agreement144: '（一）共享',
  Login_private_agreement145: '您確認，您授權平安集團，除法律另有規定之外，將您提供給平安集團的信息、享受平安集團服務產生的信息（包括本條款簽署之前提供和產生的信息）以及平安集團根據本條款約定查詢、收集的信息，用於平安集團及其因服務必要委托的合作夥伴為您提供服務、推薦產品、開展市場調查與信息數據分析。您授權平安集團，除法律另有規定之外，基於為您提供更優質服務和產品的目的，向平安集團因服務必要開展合作的夥伴提供、查詢、收集您的信息。前述「信息」可能包括但不限於您的身份信息、財產信息、賬戶信息、信用信息、交易信息、行蹤軌跡信息、電子設備信息、電子設備操作日誌及其他與您相關的信息。',
  Login_private_agreement146: '我們向合作夥伴共享您個人信息的情形如下：',
  Login_table_content01: '是否嵌入第三方代碼、插件傳輸個人信息',
  Login_table_content02: '場景描述',
  Login_table_content03: '共享目的',
  Login_table_content04: '共享信息',
  Login_table_content05: '合作夥伴',
  Login_table_content06: '會否征詢用戶同意',
  Login_table_content07: '是',
  Login_table_content08: '賬號互通',
  Login_table_content09: '通過一賬通實現帳號互聯互通',
  Login_table_content10: '帳號信息',
  Login_table_content11: '深圳平安綜合金融服務有限公司',
  Login_table_content12: '會',
  Login_table_content13: '是',
  Face_invigilator_login: '人臉監考,人臉登錄',
  Face_login: '人臉登錄',
  Face_sign: '人臉簽到',
  Login_table_content14: '使用人臉比對認證功能',
  Login_table_content15: '人臉圖片',
  Login_table_content16: '平安科技',
  Login_table_content17: '會',
  Login_table_content18: '是',
  Login_table_content19: '聲紋登錄',
  Login_table_content20: '使用聲紋比對認證功能',
  Login_table_content21: '聲音數據',
  Login_table_content22: '平安科技',
  Login_table_content23: '會',
  Login_table_content24: '是',
  Login_table_content25: '支付',
  Login_table_content26: '實現支付功能',
  Login_table_content27: '設備信息',
  Login_table_content28: '平安付、微信支付、支付寶支付、蘋果公司',
  Login_table_content29: '會',
  Login_private_agreement147: '為確保您信息的安全，平安集團對上述信息負有保密義務，並盡最大努力采取各種措施保證信息安全。本條款自您簽署時生效，具有獨立法律效力，不受本條款所屬合同或協議成立與否及效力狀態變化的影響。本條款所稱「平安集團」是指中國平安保險（集團）股份有限公司及其直接或間接控股的公司，中國平安保險（集團）股份有限公司直接或間接作為其單一最大股東的公司，以及中國平安保險（集團）股份有限公司以其他方式直接或間接控製或有重大影響的主體。',
  Login_private_agreement148: '（二）轉讓',
  Login_private_agreement149: '我們不會將您的個人信息轉讓給除知鳥及其關聯方外的任何公司、組織和個人，但以下情況除外：',
  Login_private_agreement150: '1、在事先獲取明確同意的情況下轉讓：獲得您的明確同意後，我們會向其他方轉讓您的個人信息。',
  Login_private_agreement151: '2、滿足法律法規、法律程序的要求或強製性的政府要求或司法裁定；',
  Login_private_agreement152: '3、在涉及合並、收購或破產清算時，如涉及到個人信息轉讓，我們會在要求新的持有您個人信息的公司、組織繼續受此隱私政策的約束，否則我們將要求該公司、組織重新向您征求授權同意。',
  Login_private_agreement153: '（三）公開披露',
  Login_private_agreement154: '原則上我們不會將您的信息進行公開披露。如確需公開披露，我們會向您告知公開披露的目的，披露信息的類型以及可能涉及的敏感信息，並征得您明確同意。',
  Login_private_agreement155: '根據相關法律法規和國家標準，在以下情形中，我們可能會依法共享、轉讓、公開披露您的個人信息而無需征得您的同意：',
  Login_private_agreement156: '1、與國家安全、國防安全直接相關的；',
  Login_private_agreement157: '2、與公共安全、公共衛生、重大公共利益直接相關的；',
  Login_private_agreement158: '3、與犯罪偵查、起訴、審判和判決執行等直接相關的；',
  Login_private_agreement159: '4、出於維護您或其他個人的生命、財產等重大合法權益但又很難得到本人同意的；',
  Login_private_agreement160: '5、您自行向社會公眾公開的個人信息；',
  Login_private_agreement161: '6、從合法公開披露的信息中收集個人信息的，如合法的新聞報道、政府信息公開等渠道；',
  Login_private_agreement162: '7、根據個人信息主體要求簽訂和履行合同所必需的；',
  Login_private_agreement163: '根據法律規定，共享、轉讓經去標識化處理的個人信息，且確保數據接收方無法復原並重新識別個人信息主體的，不屬於個人信息的對外共享、轉讓及公開披露行為，對此類數據的保存及處理將無需另行向您通知並征得您的同意。',
  Login_private_agreement164: '四、我們如何保護和保存您的個人信息',
  Login_private_agreement165: '（一）保存期限',
  Login_private_agreement166: '您在使用知鳥產品及服務期間，我們將持續為您保存您的個人信息。如果您註銷帳戶或主動刪除上述信息，我們將依據網絡安全法等法律法規規定保存您的信息。在您註銷帳戶或主動刪除上述信息後，我們不會再對您的個人信息進行商業化使用，但我們可能會對您的個人信息進行匿名化處理後使用。',
  Login_private_agreement167: '（二）保存地域',
  Login_private_agreement168: '您的個人信息均儲存於中華人民共和國境內。如部分產品或服務涉及跨境，我們需要向境外傳輸您的個人信息，我們會嚴格按照法律法規的規定執行，並保證您的個人信息安全。',
  Login_private_agreement169: '（三）安全措施',
  Login_private_agreement170: '1、我們會以業界成熟的安全標準和規範收集、使用、存儲和傳輸用戶信息，並通過用戶協議和隱私政策告知您相關信息的使用目的和範圍。',
  Login_private_agreement171: '2、我們非常重視信息安全。我們委派了專責團隊負責研發和應用多種安全技術和程序等，我們會對安全管理負責人和關鍵安全崗位的人員進行安全背景審查，我們建立了完善的信息安全管理製度和內部安全事件處置機製等。我們會采取符合業界標準的合理可行的安全措施和技術手段存儲和保護您的個人信息，以防止您的信息丟失、遭到被未經授權的訪問、公開披露、使用、修改、毀損、丟失或泄漏。我們會采取一切合理可行的措施，保護您的個人信息。我們會使用加密技術確保數據的保密性；我們會使用受信賴的保護機製防止數據遭到惡意攻擊。',
  Login_private_agreement172: '3、我們會對員工進行數據安全的意識培養和安全能力的培訓和考核，加強員工對於保護個人信息重要性的認識。我們部署訪問控製機製，對處理個人信息的員工進行身份認證及權限控製，並會與接觸您個人信息的員工、合作夥伴簽署保密協議，明確崗位職責及行為準則，確保只有授權人員才可訪問個人信息。若有違反保密協議的行為，會被追究相關責任。',
  Login_private_agreement173: '4、在個人信息安全事件時，我們會立即啟動應急預案，采取相應的補救措施，在最短時間內追溯原因並減少損失。與此同時，我們將按照法律法規的要求，及時向您告知安全事件的基本情況和可能的影響、我們已采取或將要采取的處理措施、您可自主防範和降低的風險的建議、對您的補救措施等。我們將及時將事件相關情況以郵件、電話、推送通知等方式告知您，難以逐一告知個人信息主體時，我們會采取合理、有效的方式發布公告。同時，我們還將按照監管部門要求，上報個人信息安全事件的處置情況。',
  Login_private_agreement174: '5、我們提醒您註意，互聯網並非絕對安全的環境，請註意確保您個人信息的安全，請使用復雜密碼，協助我們保證您的賬號以及個人信息安全。',
  Login_private_agreement175: '五、您的權利',
  Login_private_agreement176: '按照中國相關的法律、法規、標準，以及其他國家、地區的通行做法，我們保障您對自己的個人信息行使以下權利：',
  Login_private_agreement177: '（一）訪問您的個人信息',
  Login_private_agreement178: '您有權訪問您的個人信息，法律法規規定的例外情況除外。如果您想行使數據訪問權，可以通過以下方式自行訪問：',
  Login_private_agreement179: '賬戶信息——如果您希望訪問或編輯您的賬戶中的個人資料信息和支付信息、更改您的密碼，您可以通過「我的」頁面進行編輯和修改。',
  Login_private_agreement180: '如果您希望關閉您的賬戶，您可以通過「我的」-「安全中心」-「註銷帳號」自行註銷帳號或致電客服熱線400-603-8258尋求幫助。',
  Login_private_agreement181: '對於您在使用我們的產品或服務過程中產生的您的個人信息，只要我們不需要過多投入，我們可根據您的申請向您提供。',
  Login_private_agreement182: '（二）更正您的個人信息',
  Login_private_agreement183: '當您發現我們處理的關於您的個人信息有錯誤時，您有權要求我們做出更正。您可以通過「（一）訪問您的個人信息」中羅列的方式提出更正申請。',
  Login_private_agreement184: '如果您無法通過上述鏈接更正這些個人信息，您可以隨時致電客服熱線400-603-8258，我們將在30天內回復您的更正請求。',
  Login_private_agreement185: '（三）刪除您的個人信息',
  Login_private_agreement186: '您可以隨時向我們提出刪除個人信息的請求。',
  Login_private_agreement187: '若我們決定響應您的刪除請求，我們還將同時通知從我們獲得您的個人信息的實體，要求其及時刪除，除非法律法規另有規定，或這些實體獲得您的獨立授權。',
  Login_private_agreement188: '當您從我們的服務中刪除信息後，我們可能不會立即備份系統中刪除相應的信息，但會在備份更新時刪除這些信息。',
  Login_private_agreement189: '（四）改變您授權同意的範圍',
  Login_private_agreement190: '每個業務功能需要一些基本的個人信息才能得以完成（見本策略「第一部分」）。對於額外收集的個人信息的收集和使用，您可以隨時進入手機「我的-設置-個性化推薦」中關閉相應權限。',
  Login_private_agreement191: '當您收回同意後，我們將不再處理相應的個人信息。但您收回同意的決定，不會影響此前基於您的授權而開展的個人信息處理。',
  Login_private_agreement192: '如果您不想接受我們給您發送的商業廣告，您可以隨時致電客服熱線400-603-8258，我們將在15天內回復您的更正請求。',
  Login_private_agreement193: '（五）個人信息主體註銷賬戶',
  Login_private_agreement194: '您隨時可註銷此前註冊的賬戶，您可以進入手機「我的-安全中心-註銷帳號」中註銷此前註冊的賬戶。',
  Login_private_agreement195: '在註銷賬戶之後，我們將停止為您提供產品或服務，並依據您的要求，刪除您的個人信息，法律法規另有規定的除外。',
  Login_private_agreement196: '（六）個人信息主體獲取個人信息副本',
  Login_private_agreement197: '在技術可行的前提下，例如數據接口匹配，我們還可按您的要求，直接將您的個人信息副本傳輸給您。',
  Login_private_agreement198: '（七）約束信息系統自動決策',
  Login_private_agreement199: '在某些業務功能中，我們可能僅依據信息系統、算法等在內的非人工自動決策機製做出決定。如果這些決定顯著影響您的合法權益，您有權要求我們做出解釋，或要求我們關閉對您的自動決策機製。',
  Login_private_agreement200: '（八）響應您的上述請求',
  Login_private_agreement201: '為保障安全，您可能需要提供書面請求，或以其他方式證明您的身份。我們可能會先要求您驗證自己的身份，然後再處理您的請求。',
  Login_private_agreement202: '我們將在15日內答復。如您不滿意，還可以通過以下途徑投訴：',
  Login_private_agreement203: '	•	人工服務電話：400-603-8258',
  Login_private_agreement204: '	•	服務郵箱：service@zhi-niao.com',
  Login_private_agreement205: '我們將會在收到您投訴之後的十五日內答復及處理。',
  Login_private_agreement206: '對於您合理的請求，我們原則上不收取費用，但對多次重復、超出合理限度的請求，我們將視情收取一定成本費用。對於那些無端重復、需要過多技術手段（例如，需要開發新系統或從根本上改變現行慣例）、給他人合法權益帶來風險或者非常不切實際（例如，涉及備份磁帶上存放的信息）的請求，我們可能會予以拒絕。',
  Login_private_agreement207: '在以下情形中，按照法律法規要求，我們將無法響應您的請求：',
  Login_private_agreement208: '1、與國家安全、國防安全有關的；',
  Login_private_agreement209: '2、與公共安全、公共衛生、重大公共利益有關的；',
  Login_private_agreement210: '3、與犯罪偵查、起訴和審判和執行等有關的；',
  Login_private_agreement211: '4、有充分證據表明您存在主觀惡意或濫用權利的；',
  Login_private_agreement212: '5、響應您的請求將導致您或其他個人、組織的合法權益受到嚴重損害的。',
  Login_private_agreement213: '六、我們如何處理未成年的個人信息',
  Login_private_agreement214: '我們的產品、網站和服務只面向成人。如果沒有父母或監護人的同意，未成年人不得創建自己的用戶賬戶。',
  Login_private_agreement215: '對於經父母同意而收集未成年人個人信息的情況，我們只會在受到法律允許、父母或監護人明確同意或者保護未成年人所必要的情況下使用或公開披露此信息。如果我們發現自己在未事先獲得可證實的監護人同意的情況下收集了未成年人的個人信息，則會設法盡快刪除相關內容。',
  Login_private_agreement216: '盡管當地法律和習俗對兒童的定義不同，但我們將不滿 18 周歲的任何人均視為非成年人。對於經父母或監護人同意而收集兒童個人信息的情況，我們只會在受到法律允許、父母或監護人明確同意或者保護兒童所必要的情況下使用或公開披露此信息。如果我們發現自己在未事先獲得可證實的父母或監護人同意的情況下收集了兒童的個人信息，則會設法盡快刪除相關數據。',
  Login_private_agreement217: '七、本隱私權政策如何更新',
  Login_private_agreement218: '我們可能適時會對本隱私權政策進行調整或變更，本隱私權政策的任何更新將以推送消息的方式公布，並且標註更新時間。除法律法規或監管規定另有強製性規定外，經調整或變更的內容一經通知或公布後的1日後生效。如該等變更會導致您在本政策項下權利的實質減損，我們將在變更生效前，通過在頁面顯著位置提示的方式通知您。在該種情況下，如您在隱私權政策調整或變更後繼續使用我們提供的任一服務或訪問我們相關網站的，我們相信這代表您已充分閱讀、理解並接受修改後的隱私權政策並受其約束。',
  Login_private_agreement219: '對於重大變更，我們還會提供更為顯著的通知（我們會通過包括但不限於郵件、短信或在瀏覽頁面做特別提示等方式，說明隱私政策的具體變更內容）。',
  Login_private_agreement220: '本政策所指的重大變更包括但不限於：',
  Login_private_agreement221: '（一）我們的服務模式發生重大變化。如處理個人信息的目的、處理的個人信息類型、個人信息的使用方式等；',
  Login_private_agreement222: '（二）我們在所有權結構、組織架構等方面發生重大變化。如業務調整、破產並購等引起的所有者變更等；',
  Login_private_agreement223: '（三）個人信息共享、轉讓或公開披露的主要對象發生變化；',
  Login_private_agreement224: '（四）您參與個人信息處理方面的權利及其行使方式發生重大變化；',
  Login_private_agreement225: '（五）我們負責處理個人信息安全的責任部門、聯絡方式及投訴渠道發生變化時；',
  Login_private_agreement226: '（六）個人信息安全影響評估報告表明存在高風險時。',
  Login_private_agreement227: '八、如何聯系我們',
  Login_private_agreement228: '如果您對本隱私政策有任何疑問、意見或建議，可致電客服熱線400-603-8258。',
  Login_private_agreement229: '名詞解釋：',
  Login_private_agreement230: '個人信息是指以電子或者其他方式記錄的能夠單獨或者與其他信息結合識別特定自然人身份或者反映特定自然人活動情況的各種信息。個人信息包括姓名、出生日期、身份證件號碼、個人生物識別信息、住址、通信通訊聯系方式、通信記錄和內容、賬號密碼、財產信息、征信信息、行蹤軌跡、住宿信息、健康生理信息、交易信息等。',
  Login_private_agreement231: '個人敏感信息是指一旦泄露、非法提供或濫用可能危害人身和財產安全，極易導致個人名譽、身心健康受到損害或歧視性待遇等的個人信息。個人敏感信息包括身份證件號碼、個人生物識別信息、銀行賬號、通信記錄和內容、財產信息、征信信息、行蹤軌跡、住宿信息、健康生理信息、交易信息、18歲以下（含）未成年的個人信息等。',
  Login_private_agreement232: '設備是指可用於使用平安產品和/或服務的裝置，例如桌面設備、平板電腦或智能手機。',
  Login_private_agreement233: '唯一設備標識符是指具有唯一性的設備標識符（有時稱為通用專屬 ID 或 UUID）是指由設備製造商編入到設備中的一串字符，可用於以獨有方式標識相應設備（例如國際移動設備身份碼IMEI號、網絡設備硬件地址MAC）。不同的設備標識符在有效期、用戶是否可以重置以及獲取方式方面會有所不同。相應設備可能會有多個不同的具有唯一性的設備標識符。唯一設備標識符可用於多種用途，其中包括安全性和欺詐檢測、同步服務（如用戶的電子郵件收件箱）、記錄用戶的偏好設置以及提供具有相關性的廣告。',
  Login_private_agreement234: 'Cookie是指支持服務器端（或者腳本）在客戶端上存儲和檢索信息的一種機製，通過增加簡單、持續的客戶端狀態來擴展基於Web的客戶端/服務器應用。服務器在向客戶端返回HTTP對象的同時發送一條狀態信息，並由客戶端保存。狀態信息中說明了該狀態下有效的URL範圍。此後，客戶端發起的該範圍內的HTTP請求都將把該狀態信息的當前值從客戶端返回給服務器，這個狀態信息被稱為Cookie。',
  Login_private_agreement235: '匿名標示符是指平安公司基於設備參數，通過機器算法，生成一個標示符例如BAIDUID、CUID，幫助平安識別一個用戶，為其提供更好的產品和/或服務與改善用戶體驗。',
  Login_private_agreement236: '用戶畫像是指通過收集、匯聚、分析個人信息，對某特定自然人個人特征，如其職業、經濟、健康、教育、個人喜好、信用、行為等方面做出分析或預測，形成其個人特征模型的過程。直接使用特定自然人的個人信息，形成該自然人的特征模型，稱為直接用戶畫像。使用來源於特定自然人以外的個人信息，如其所在群體的數據，形成該自然人的特征模型，稱為間接用戶畫像。',
  Login_private_agreement237: '匿名化是指通過對個人信息的技術處理，使得個人信息主體無法被識別，且處理後的信息不能被復原的過程。個人信息經匿名化處理後所得的信息不屬於個人信息。',
  Login_private_agreement238: '本軟件是指深圳平安通信科技公司之本軟件平臺及網站、程序、服務、工具及客戶端。',
  Login_private_agreement239: '關聯公司是指」本軟件」移動應用的經營者深圳平安通信科技有限公司及其他與平安公司存在關聯關系的公司的單稱或合稱。「關聯關系」是指對於任何主體（包括個人、公司、合夥企業、組織或其他任何實體）而言，即其直接或間接控製的主體，或直接或間接控製其的主體，或直接或間接與其受同一主體控製的主體。前述「控製」指，通過持有表決權、合約或其他方式，直接或間接地擁有對相關主體的管理和決策作出指示或責成他人作出指示的權力或事實上構成實際控製的其他關系。',

  Login_registration_items:'報名項目：',
  Login_term_validity:'有效期：',
  Login_one_year:'一年',
  Login_price_items:'項目價格：',
  Login_reminbi:'￥',
  Login_free:'免費',
  Login_group:'集團',
  Login_accout_number:'賬號',
  Login_registration:"註 冊",
  Login_retrieve_pwd:'找回賬戶密碼',
  Login_next_step:'下一步',
  login_failed:'登錄失敗',
  Login_id_verification_failed:'你的身份校驗未通過，',
  Login_mobile_number_login:'手機號登錄',
  Login_contact_servicer:'或者聯系客服',
  Login_service_num_time:'服務熱線：400-603-8258（工作日9:30-18:00）',
  Login_service_email:'服務郵箱：service@zhi-niao.com',
  Login_signing_in:'正在登錄',
  Login_platformName:'註冊{platformName}賬號'
}
